import './index.pcss';
import Alpine from 'alpinejs';
import { ApiShop, ShopInfos } from "../../../types/shop";

import Swiper from 'swiper';
import type { SwiperOptions } from 'swiper/types';
import { Autoplay } from 'swiper/modules';

// import styles bundle
import 'swiper/css';
import { storeLocatorStore, storeLocatorStoreFromBO } from '../../../scripts/helpers/storeLocator';
import { getUserData } from '../../../helpers/user'
import { waitForShopUrlSelection } from '../../../scripts/helpers/shopUrlSelection';
import { AlpineComponentTryba } from '../../../scripts/alpine/include/global';


document.addEventListener('alpine:init', () => {
    Alpine.data('initMenu', (isProductPage = false, mainMenuId = false): AlpineComponentTryba => {
        return {
            menuIsInTop: true, // boolean: indique si le menu sticky est en dessous de 64 px
            menuIsOpen: false, // boolean: indique si le menu burger est ouvert mobile
            menuDesktopIsOpen: false, // boolean: indique si le menu desktop est ouvert
            submenuOpen: 0, // number: indique l'index du sous menu ouvert
            accordionOpen: 'gammes', // string: indique la key de l'accordéon ouvert par défaut dans le menu burger
            showDevisCtaTooltip: false, // boolean: statut initial du tooltip sur le bouton de devis
            delayDevisCtaTooltip: 30000, // number (milleseconds): delai d'apparition du tooltip
            showSub: isProductPage ? false : undefined,
            pdvStoredName: '',
            pdvStoredLink: '',
            pdvTabOpen: false,
            pdvShopCode: '',
            isFixed: false, // boolean: indique si le header est fixé en rapport avec menuHasBg
            menuHasBg: false, // background state
            menuBgForced: false, // valeur cible lue par les listeners mouseout (cf. handleBackgroundMenu)
            bgListenersBound: false, // garde: les listeners de background ne sont attachés qu'une seule fois
            menu: '', // Menu html element
            idShowMenu: 0, // Id de l'item du menu
            idShowSubMenu: 0, // Id de l'item du sous menu
            closeSlider: true, // Ferme le slider de réassurance
            api_url: window.location.origin + '/api/shop/',
            swiper: {},
            swiperMobile: {},
            sliderPause: false,
            mobile_menu_api: window.location.origin + '/_internal/menu-mobile' + (mainMenuId ? '?mainMenuId=' + mainMenuId : ''),
            changeShop: false,
            pdvInfos: {
                name: '',
                address: '',
                city: '',
                phone: '',
                timeSheet: '',
            } as ShopInfos,
            lastScrollPosition: 0,
            stickyMenuTicking: false, // garde anti-réentrance rAF pour handleStickyMenu
            init() {
                this.$watch('$store.scroll.scrollY', (scrollY: number) => {
                    this.menuIsInTop = scrollY < 64;
                    if (scrollY === 0 && this.showSub !== undefined) {
                        this.showSub = false;
                    }
                });

                window.addEventListener('keydown', (e) => {
                    if (e.keyCode === 27) {
                        this.pdvTabOpen = false;
                        if(this.menuDesktopIsOpen) {
                            this.closeMenuDesktop();
                        }
                    }
                });

                /**
                 * Attention sur la page PDV, ce menu peut etre a undefined, car il y a deux menus :
                 * le menu main et le menu sticky des ancres
                 */
                this.menu = this.$refs.mainMenu;
                const mobileContainer = document.getElementById('mobile-menu-root');
                if (this.$store.global.isMobile && mobileContainer) {
                    fetch(`${this.mobile_menu_api}`)
                        .then(async (response: Response) => {
                            if (!response.ok) {
                                console.error('Unable to load mobile menu', {
                                    status: response.status,
                                    statusText: response.statusText,
                                    url: response.url,
                                });

                                return;
                            }

                            try {
                                const menuMobile = await response.text();
                                mobileContainer.innerHTML = menuMobile;
                            } catch (e) {
                                if (e instanceof SyntaxError) {
                                    console.error('Retour serveur non conforme JSON');
                                } else {
                                    console.error(e);
                                }
                            }
                        })
                        .catch((error) => {
                            console.error('Unable to load mobile menu', error);
                        });
                }

                // const body = document.getElementById('mainContent') as HTMLBodyElement;
                const body = document.querySelector('body') as HTMLBodyElement;
                // Padding top of hero (transparent header)
                const sliderOffer = this.$refs.sliderInfo;

                if (sliderOffer) {
                    this.closeSlider = false;
                }

                const type = body.dataset.type;
                const hasMenuBgInBodyAttr = body.getAttribute('data-menu-bg') === 'true';
                if (hasMenuBgInBodyAttr) {
                    let hero: null|HTMLElement = null;
                    this.handleBackgroundMenu(false);
                    this.isFixed = true;
                    if (type == 'homepage' || type === 'page') {
                        hero = body.querySelector('#mainContent > div') as HTMLDivElement;
                    } else if (type == 'landingPage') {
                        hero = body.querySelector('main section.landing .relative') as HTMLDivElement;
                    } else if (type == 'range') {
                        hero = body.querySelector('section') as HTMLDivElement;
                    } else if (type == 'shop') {
                        hero = body.querySelector('.shop-header') as HTMLDivElement;
                    }

                    if (hero) {
                        if (this.closeSlider == false) {
                            hero.style.paddingTop = this.$store.global.isMobile ? `100px` : `148px`;
                        } else {
                            hero.style.paddingTop = this.$store.global.isMobile ? `124px` : `56px`;
                        }
                    }


                    // Gestion du background menu au scroll : throttlé via requestAnimationFrame
                    // pour ne pas occuper le main thread à chaque frame de scroll (INP).
                    let bgScrollTicking = false;
                    window.addEventListener('scroll', () => {
                        if (bgScrollTicking) {
                            return;
                        }
                        bgScrollTicking = true;
                        requestAnimationFrame(() => {
                            bgScrollTicking = false;
                            if (window.scrollY < 64 && this.menuDesktopIsOpen == false) {
                                if (this.menu) {
                                    // Hover gives background
                                    this.closeSlider == false ? this.menu.classList.add('lg:-top-[68px]') : this.menu.classList.add('lg:-top-[44px]')
                                }
                                // On ne réécrit l'état réactif que s'il change réellement
                                if (this.menuHasBg !== false) {
                                    this.menuHasBg = false;
                                }
                                // Listeners déjà attachés (init) : on ne fait que varier la valeur cible
                                this.menuBgForced = false;
                            } else {
                                // Always has background
                                if (this.menuHasBg !== true) {
                                    this.menuHasBg = true;
                                }
                                this.menuBgForced = true;
                            }
                        });
                    })
                } else {
                    this.menuHasBg = true
                }

                // PAdding position fixed mobile
                if (this.$store.global.isMobile && this.isFixed == false) {
                    if (this.closeSlider == false) {
                        document.querySelector('body')?.classList.add('pt-[88px]');
                    } else {
                        document.querySelector('body')?.classList.add('pt-[64px]');
                    }
                }

                // Gestion du tooltip sur le bouton demande de devis
                setTimeout(() => {
                    this.showDevisCtaTooltip = true;
                }, this.delayDevisCtaTooltip);

                setTimeout(() => {
                    this.handleDatasFromStorage()
                }, 200);

                // Launch slider after 1s to optimize page load
                window.setTimeout(() => {
                    this.handleMenuSlider()
                }, 2500);

                // Gère le sticky menu sur les pages produits
                if(!this.$store.global.isMobile) {
                    window.addEventListener('DOMContentLoaded', () => {
                        this.handleProductStickyMenu();
                    })
                }
               
            },
            handleProductStickyMenu() {
                // Sur les pages produit, le header doit se cacher quand le menu
                // d'ancres (.js-product-anchor-menu) devient sticky (collé en
                // haut), et réapparaître progressivement quand il ne l'est plus.
                // Sans ce comportement, les deux menus se superposent car le menu
                // d'ancres a un z-index plus élevé que le header.
                const stickyMenu = document.querySelector('.js-product-anchor-menu') as HTMLDivElement;
                if (!stickyMenu) return;
                const header = this.$refs.mainMenu as HTMLElement;

                // Le header a par défaut la classe CSS "lg:sticky lg:-top-[77px]".
                // Ce "-77px" sert sur d'autres types de pages à faire disparaître
                // la petite barre d'info du haut pendant le scroll : le header
                // reste collé en haut, mais avec ses 77 premiers pixels remontés
                // hors de l'écran.
                //
                // Sur la page produit, c'est nous (plus bas) qui décidons entièrement
                // de la position du header avec un translateY. Si on laisse ce
                // "-77px" natif actif en plus de notre translateY, les deux
                // décalages s'additionnent : notre calcul suppose que le bord haut
                // du header est à y=0 quand il est pleinement visible, alors qu'en
                // réalité le CSS natif le décale déjà de 77px. Ça crée un espace
                // vide entre le bas du header et le haut du menu d'ancres, de la
                // taille de ce décalage.
                // On fixe donc "top: 0" en dur (en style inline, donc plus
                // prioritaire que la classe Tailwind) pour neutraliser ce
                // comportement natif : notre translateY devient la seule chose
                // qui bouge le header sur cette page.
                header.style.top = '0px';

                // Publie la hauteur réellement visible du header dans
                // --header-visible-height : le média sticky des headers produit
                // (templates/comp/Product/*Header) s'y colle, au lieu d'une
                // valeur fixe qui le laissait passer sous le menu.
                const publishVisibleHeight = (visibleHeight: number) => {
                    document.documentElement.style.setProperty('--header-visible-height', `${Math.max(0, Math.round(visibleHeight))}px`);
                };

                const syncProductStickyMenuState = () => {
                    // stickyMenuTop = distance en pixels entre le haut de l'écran
                    // et le haut du menu d'ancres.
                    // - Le menu d'ancres est en "position: sticky; top: 0". Il est
                    //   donc réellement collé en haut exactement quand cette
                    //   distance vaut 0 (ou moins).
                    // - Tant qu'il n'est PAS collé, cette distance nous dit
                    //   combien de pixels on a remonté depuis le point où il se
                    //   décolle : c'est cette même valeur qu'on réutilise plus bas
                    //   pour faire glisser le header en même temps que le scroll.
                    //
                    // Pourquoi lire cette valeur en direct à chaque scroll, plutôt
                    // que de calculer une position une seule fois au chargement ?
                    // Parce qu'un élément "position: sticky" peut déjà être collé
                    // au moment où la page se charge (si on recharge la page au
                    // milieu). Dans ce cas, sa position mesurée une seule fois
                    // correspondrait à sa position collée (donc fausse), et pas à
                    // sa vraie position d'origine dans la page. Relire sa position
                    // réelle à chaque scroll évite ce piège.
                    const stickyMenuTop = stickyMenu.getBoundingClientRect().top;
                    const headerHeight = header.offsetHeight;

                    if (stickyMenuTop <= 0) {
                        // Cas 1 : le menu d'ancres est collé en haut. Le header
                        // doit être entièrement caché, remonté hors de l'écran.
                        header.style.transition = '';
                        header.style.transform = `translateY(-100%)`;
                        header.style.opacity = `0`;
                        header.style.pointerEvents = `none`;
                        publishVisibleHeight(0);
                    } else if (stickyMenuTop >= headerHeight) {
                        // Cas 2 : on est assez loin du menu d'ancres (plus loin
                        // que la hauteur du header) pour que le header soit
                        // entièrement visible sans jamais toucher le menu d'ancres.
                        header.style.transition = '';
                        header.style.transform = `translateY(0)`;
                        header.style.opacity = `1`;
                        header.style.pointerEvents = `auto`;
                        publishVisibleHeight(headerHeight);
                    } else {
                        // Cas 3 : zone de transition. On est entre les deux cas
                        // précédents : le menu d'ancres n'est pas encore collé,
                        // mais il est assez proche pour que le header, s'il était
                        // pleinement affiché, le chevaucherait.
                        // On cache seulement la partie du header qui dépasserait
                        // par-dessus le menu d'ancres : hiddenHeight = la portion
                        // du header (en pixels) qui doit rester hors champ.
                        // Résultat : le bas visible du header touche toujours
                        // exactement le haut du menu d'ancres, sans jamais les
                        // superposer et sans jamais laisser un vide entre les deux.
                        //
                        // Pas de transition CSS ici : le déplacement doit suivre
                        // le scroll au pixel près. Une transition (même courte)
                        // ferait "traîner" le header derrière le scroll, donnant
                        // une impression de décalage/lag au lieu d'un mouvement
                        // parfaitement synchronisé.
                        header.style.transition = 'none';
                        const hiddenHeight = headerHeight - stickyMenuTop;
                        header.style.transform = `translateY(-${hiddenHeight}px)`;
                        header.style.opacity = `1`;
                        header.style.pointerEvents = `auto`;
                        publishVisibleHeight(stickyMenuTop);
                    }
                };

                // On appelle la fonction une première fois immédiatement, en plus
                // de l'écoute du scroll juste après. Pourquoi : l'événement
                // 'scroll' ne se déclenche que quand l'utilisateur scrolle. Si la
                // page se charge déjà scrollée au-delà du menu d'ancres, aucun
                // scroll ne se produit tout de suite, donc sans cet appel initial
                // le header resterait dans son état par défaut (visible), caché
                // derrière le menu d'ancres (z-index plus élevé) jusqu'au premier
                // scroll qui fait retomber juste sur le bon calcul.
                syncProductStickyMenuState();
                window.addEventListener('scroll', syncProductStickyMenuState);
                // La hauteur du header change sans scroll (fermeture du bandeau
                // d'info, ouverture du méga-menu, redimensionnement).
                new ResizeObserver(syncProductStickyMenuState).observe(header);
            },
            async handleDatasFromStorage() {
                const selectedShop = await waitForShopUrlSelection();
                const userData = getUserData();
                if (userData && userData.shop) {
                    const shopCode = userData.shop.clientNumber;
                    this.pdvShopCode = shopCode;
                    if (userData.shop.city) {
                        this.pdvStoredName = userData.shop.city.toLowerCase()
                    }
                    if (userData.shop.url) {
                        this.pdvStoredLink = userData.shop.url
                    }
                    if (selectedShop?.clientNumber === shopCode) {
                        this.displayPdvDatas(selectedShop);
                        return;
                    }
                    storeLocatorStore(shopCode)
                        .then((store) => {
                            this.displayPdvDatas(store)
                            storeLocatorStoreFromBO(shopCode)
                                .then((boStore) => {
                                    this.displayPdvDatas(boStore)
                                }).catch((e) => {
                                    if (e instanceof SyntaxError) {
                                        console.error('Retour serveur (back-office) non conforme JSON');
                                    } else {
                                        console.error(e);
                                    }
                                });
                        })
                        .catch((e) => {
                            if (e instanceof SyntaxError) {
                                console.error('Retour serveur non conforme JSON');
                            } else {
                                console.error(e);
                            }
                        });
                }
            },
            handleMenuSlider() {
                // Slider top reinsurance
                const swiperParams: SwiperOptions = {
                    modules: [Autoplay],
                    init: true,
                    loop: true,
                    direction: 'vertical',
                    slidesPerView: 1,
                    autoHeight: true,
                    autoplay: {
                        delay: 2500,
                    }
                };

                this.swiperMobile = new Swiper(
                    this.$refs.swiperContainerMobile,
                    swiperParams,
                );

                this.swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams,
                );
            },
            closeSliderFunction(e: Event) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
                this.closeSlider = true;
                if (this.menu) {
                    if (this.isFixed) {
                        this.menu.classList.remove('lg:-top-[68px]')
                    } else {
                        this.menu.classList.remove('lg:-top-[77px]')
                    }
                    //Product page header avec un comportement différent
                    if (this.type == 'product') {
                        this.menu.classList.add('lg:!-top-11')
                    } else {
                        this.menu.classList.add('lg:-top-11')
                    }
                }

                if (this.$store.global.isMobile) {
                    if (this.isFixed == false) {
                        //mobile éviter un padding top à la fermture du slider (28px)
                        document.querySelector('body')?.classList.remove('pt-[128px]');
                        document.querySelector('body')?.classList.add('pt-[100px]');
                    }
                    const mobileBar = this.$refs.stickyHeader.querySelector('.container');
                    mobileBar?.classList.remove('mt-6')
                    // 100px = mobile bar 64px + navigation page 36px
                    this.$refs.burgerMenu.classList.add('!top-[100px]')
                    this.$refs.burgerMenu.style.height = 'calc(100vh - 100px)'
                }
            },
            // Pause slider reinsurance
            pauseSlider() {
                if (this.sliderPause == false) {
                    this.sliderPause = true;
                    this.swiper.autoplay.stop();
                    this.swiperMobile.autoplay.stop();
                } else {
                    this.sliderPause = false;
                    this.swiper.autoplay.start();
                    this.swiperMobile.autoplay.start();
                }
            },
            //hover background state handler
            handleBackgroundMenu(forceBg: boolean) {
                // On ne fait que mémoriser la valeur cible : les handlers la lisent dynamiquement.
                this.menuBgForced = forceBg;

                // Les listeners ne sont attachés qu'une seule fois (évite l'accumulation au scroll).
                if (this.bgListenersBound || !this.menu) {
                    return;
                }
                this.bgListenersBound = true;

                // Pour que lorsqu'on ferme le slider le menu ne devienne pas blanc
                if (this.$store.global.isMobile) {
                    this.menu.addEventListener('click', () => {
                        this.menuHasBg = true
                    })
                    this.menu.addEventListener('mouseout', () => {
                        this.menuHasBg = this.menuBgForced
                    })
                } else {
                    this.menu.addEventListener('mouseover', () => {
                        this.menuHasBg = true
                    })
                    this.menu.addEventListener('mouseout', () => {
                        this.menuHasBg = this.menuBgForced
                    })
                }
            },
            handleStickyTopMenu() {
                const currentScrollPosition = window.pageYOffset;
                // if (this.isFixed) {
                const header = document.querySelector('header');
                if (currentScrollPosition > this.lastScrollPosition) {
                    if (header && header.classList.contains('!top-0')) {
                        header.classList.remove('!top-0')
                    }
                } else if ((currentScrollPosition < this.lastScrollPosition) && header) {
                    header.classList.add('!top-0')
                }
                // } else {
                //     console.log(this.menu)
                //     let menuDesktop = document.querySelector('.js-menu-header') as HTMLDivElement
                //     let topValue = this.menu.offsetHeight - menuDesktop.offsetHeight;
                //     if (currentScrollPosition > this.lastScrollPosition) {
                //         if(document.querySelector('header')!.classList.contains(`-top-[${topValue}px]`)) {
                //             document.querySelector('header')!.classList.remove(`-top-[${topValue}px]`)
                //         }
                //     } else if (currentScrollPosition < this.lastScrollPosition) {
                //         document.querySelector('header')!.classList.add(`-top-[${topValue}px]`)
                //     }
                // }

                this.lastScrollPosition = currentScrollPosition;
            },
            handleStickyMenu() {
                // Throttle via rAF : un seul recalcul d'état par frame de scroll.
                if (this.stickyMenuTicking) {
                    return;
                }
                this.stickyMenuTicking = true;
                requestAnimationFrame(() => {
                    this.stickyMenuTicking = false;
                    const st = window.scrollY || document.documentElement.scrollTop;
                    const scrollUp = st <= this.$store.scroll.scrollY;

                    // On ne réécrit l'état réactif du store que lorsqu'il change réellement.
                    if (this.$store.scroll.scrollUp !== scrollUp) {
                        this.$store.scroll.scrollUp = scrollUp;
                    }
                    if (this.$store.scroll.scrollY !== st) {
                        this.$store.scroll.scrollY = st;
                    }
                });
            },
            openSubmenu(index: number) {
                this.submenuOpen = index;
                this.$refs.burgerMenu.scrollTo({ top: 0, behavior: 'smooth' });
            },
            openElMenuDesktop(el) {
                if (el == this.idShowMenu) {
                    this.idShowMenu = 0;
                    this.menuDesktopIsOpen = false
                } else {
                    this.menuDesktopIsOpen = true
                    this.menuHasBg = true;
                    this.idShowMenu = el;
                    this.handleBackgroundMenu(true)
                }
            },
            openElMenuDesktopHover(el) {
                this.menuDesktopIsOpen = true
                this.menuHasBg = true;
                this.idShowMenu = el;
                this.handleBackgroundMenu(true)
            },
            openElMenuMobile(el) {
                if (el == 0) {
                    this.idShowMenu = 0;
                    this.$refs.burgerMenu.style.zIndex = '100';
                    this.$refs.burgerMenu.style.overflowY = 'auto'
                }
                else if (el == this.idShowMenu) {
                    this.idShowMenu = 0;
                    this.$refs.burgerMenu.style.zIndex = '100';
                    this.$refs.burgerMenu.style.overflowY = 'auto'
                } else {
                    this.idShowMenu = el;
                    this.$refs.burgerMenu.style.zIndex = '1030'
                    this.$refs.burgerMenu.style.overflowY = 'visible'
                }
            },

            openElSubMenuMobile(el) {
                if (el == 0) {
                    this.idShowSubMenu = 0;
                    this.$refs.burgerMenu.style.overflowY = 'visible'
                }
                else if (el == this.idShowMenu) {
                    this.idShowSubMenu = 0;
                    this.$refs.burgerMenu.style.overflowY = 'auto'
                } else {
                    this.idShowSubMenu = el;
                    this.$refs.burgerMenu.style.overflowY = 'visible'
                }
            },

            closeMenuDesktop() {
                this.idShowMenu = 0;
                this.menuDesktopIsOpen = false;
            },
            closeMenu() {
                this.menuIsOpen = false;
                this.idShowSubMenu = 0;
                this.idShowMenu = 0;
                this.$refs.burgerMenu.style.overflowY = 'auto'
            },
            openMenu() {
                this.menuIsOpen = true;
            },
            openPdvTab() {
                this.pdvTabOpen = !this.pdvTabOpen;
                if (this.pdvTabOpen) {
                    setTimeout(() => {
                        const btnId = (!this.pdvStoredName || this.pdvShopCode == '' || this.changeShop)
                            ? 'no-shop-close-btn'
                            : 'shop-close-btn';
                        (document.getElementById(btnId) as HTMLElement)?.focus();
                    }, 350);
                }
            },
            changeShopFct() {
                this.changeShop = true;
                this.$nextTick(() => {
                    document.getElementById('sideTabInput')?.focus()
                })
            },
            displayPdvDatas(datas: ApiShop) {
                this.pdvInfos.marketingName = datas.marketingName;
                this.pdvInfos.name = datas.name;
                this.pdvInfos.address = datas.address;
                this.pdvInfos.city = datas.city;
                this.pdvInfos.phone = datas.phone;
                this.pdvInfos.timeSheet = datas.htmlTimesheet;
                // Lien Local Ranker (page du magasin sur le Store Locator), sinon lien déjà mémorisé.
                if (datas.storeLocatorUrl) {
                    this.pdvStoredLink = datas.storeLocatorUrl;
                }
            },
        };
    });
});
